import { DeviceEditConfig } from "..";

export const defaultDeviceInfoState: DeviceEditConfig = {
    auth_bearer: "",
    device_name: "",
    rdm_endpoint: "",
    uses_own_config: false,
};
